/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__tabs__settings__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Sie können diese Einstellungen auch bei der Routensuche ändern.`
};

const en_profile__tabs__settings__banner = /** @type {(inputs: {}) => string} */ () => {
	return `You can also modify these parameters when searching for your route.`
};

const es_profile__tabs__settings__banner = /** @type {(inputs: {}) => string} */ () => {
	return `También podrás modificar estos parámetros al buscar tu itinerario.`
};

const fr_profile__tabs__settings__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Vous pourrez aussi modifier ces paramètres lors de la recherche de votre itinéraire.`
};

const it_profile__tabs__settings__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Puoi anche modificare questi parametri durante la ricerca del percorso.`
};

const nl_profile__tabs__settings__banner = /** @type {(inputs: {}) => string} */ () => {
	return `U kunt deze parameters ook wijzigen tijdens het zoeken naar uw route.`
};

const pt_profile__tabs__settings__banner = /** @type {(inputs: {}) => string} */ () => {
	return `Também pode modificar estes parâmetros quando procura o seu itinerário.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__banner = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__tabs__settings__banner(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__tabs__settings__banner", locale)
	if (locale === "de") return de_profile__tabs__settings__banner(inputs)
	if (locale === "en") return en_profile__tabs__settings__banner(inputs)
	if (locale === "es") return es_profile__tabs__settings__banner(inputs)
	if (locale === "fr") return fr_profile__tabs__settings__banner(inputs)
	if (locale === "it") return it_profile__tabs__settings__banner(inputs)
	if (locale === "nl") return nl_profile__tabs__settings__banner(inputs)
	return pt_profile__tabs__settings__banner(inputs)
};